import { slideIn, slideOut } from '../animations';

let thanks = null;

export function setThanks(val) {
  thanks = val;
}

export default function thanksStep(presentation) {
  const { elements, presentations } = presentation;

  const { thanks: thanksElement, thanksFirstName } = elements;

  if (!thanks) {
    return;
  }

  Promise.resolve().then(() => {
    if (presentation.currentId !== 'thanks') {
      // We navigated out of thanks, lets get rid of it
      thanks = null;
      presentations.fadePromise.then(() => {
        presentations.reset();
      });
    }
  });

  thanksFirstName.textContent = thanks.firstName;

  presentation.addStep({
    id: 'thanks',
    default: {
      enter({ timeline, label }) {
        slideIn(thanksElement)({ timeline, label });
        // Reset when left the form
        timeline.call(
          () => {
            if (
              // eslint-disable-next-line no-underscore-dangle
              !timeline._forcingPlayhead &&
              timeline.reversed() &&
              thanks !== null
            ) {
              thanks = null;
              presentations.reset();
            }
          },
          null,
          null,
          label,
        );
      },
      leave: slideOut(thanksElement),
    },
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/steps/thanks.js